"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetReviewAverageByProductIdServerQueryOptions = exports.getReviewAverageByProductIdServer = exports.useGetReviewAverageByProductIdQueryOptions = exports.getReviewAverageByProductId = void 0;
exports.useGetReviewAverageByProductId = useGetReviewAverageByProductId;
exports.useGetReviewAverageByProductIdServer = useGetReviewAverageByProductIdServer;
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
const react_query_1 = require("@tanstack/react-query");
const queryFetch_1 = require("../../utils/orval/queryFetch");
const queryKeyMutator_1 = require("../../utils/orval/queryKeyMutator");
/**
 * @summary Finds the review average for the given product on the given webshop.
 */
const getReviewAverageByProductId = (params, operationName = 'getReviewAverageByProductId', options, signal) => {
    return (0, queryFetch_1.queryFetch)({ url: `/undefined`, method: 'GET', params, signal }, Object.assign({ operationName: 'getReviewAverageByProductId' }, options));
};
exports.getReviewAverageByProductId = getReviewAverageByProductId;
const useGetReviewAverageByProductIdQueryOptions = (params, operationName = 'getReviewAverageByProductId', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ params, operationName }, { url: `/undefined`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getReviewAverageByProductId)(params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn }, queryOptions);
};
exports.useGetReviewAverageByProductIdQueryOptions = useGetReviewAverageByProductIdQueryOptions;
/**
 * @summary Finds the review average for the given product on the given webshop.
 */
function useGetReviewAverageByProductId(params, operationName = 'getReviewAverageByProductId', options) {
    const queryOptions = (0, exports.useGetReviewAverageByProductIdQueryOptions)(params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
/**
 * @summary Finds the review average for the given product on the given webshop.
 */
const getReviewAverageByProductIdServer = (productId, params, operationName = 'getReviewAverageByProductId', options, signal) => {
    return (0, queryFetch_1.queryFetch)({ url: `/public/review/average/v2/${productId}`, method: 'GET', params, signal }, Object.assign({ operationName: 'getReviewAverageByProductId' }, options));
};
exports.getReviewAverageByProductIdServer = getReviewAverageByProductIdServer;
const useGetReviewAverageByProductIdServerQueryOptions = (productId, params, operationName = 'getReviewAverageByProductId', options) => {
    const { query: queryOptions, request: requestOptions } = options !== null && options !== void 0 ? options : {};
    const queryKey = (0, queryKeyMutator_1.queryKeyMutator)({ productId, params, operationName }, { url: `/public/review/average/v2/${productId}`, queryOptions });
    const queryFn = ({ signal }) => (0, exports.getReviewAverageByProductIdServer)(productId, params, operationName, requestOptions, signal);
    return Object.assign({ queryKey, queryFn, enabled: !!productId }, queryOptions);
};
exports.useGetReviewAverageByProductIdServerQueryOptions = useGetReviewAverageByProductIdServerQueryOptions;
/**
 * @summary Finds the review average for the given product on the given webshop.
 */
function useGetReviewAverageByProductIdServer(productId, params, operationName = 'getReviewAverageByProductId', options) {
    const queryOptions = (0, exports.useGetReviewAverageByProductIdServerQueryOptions)(productId, params, operationName, options);
    const query = (0, react_query_1.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
//# sourceMappingURL=review-service.js.map